import React, { useState } from 'react'
import Modal from 'components/modal'
import Button from 'components/button'
import Input from 'components/input'
import { useApplicationStore } from 'hooks/application'

interface AssignPaidUserModalProps {
  open: boolean
  onClose: () => void
  onAssign: (email: string) => Promise<void>
}

const AssignPaidUserModal: React.FC<AssignPaidUserModalProps> = ({ open, onClose, onAssign }) => {
  const [email, setEmail] = useState('')
  const [assigning, setAssigning] = useState(false)
  const { displayErrorMessage } = useApplicationStore()

  const processEmails = async (emails: string[]) => {
    for (const e of emails) {
      await onAssign(e)
    }
  }

  const handleAssign = () => {
    const emails = email
      .split(',')
      .map((e) => e.trim().toLowerCase())
      .filter((e) => e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e))
    if (emails.length === 0) return
    setAssigning(true)
    processEmails(emails)
      .then(() => {
        setAssigning(false)
        setEmail('')
        onClose()
      })
      .catch((e) => {
        setAssigning(false)
        displayErrorMessage(e)
      })
  }

  return (
    <Modal id="assign-seat" title="Assign Paid User" open={open} setOpen={onClose}>
      <p className="text-sm text-muted mb-3">
        Enter one or more email addresses (comma-separated) to assign paid seats.
      </p>
      <Input
        type="text"
        className="p-2"
        placeholder="Enter email addresses (comma-separated)..."
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleAssign()
        }}
      />
      <div className="flex items-center justify-end gap-2 mt-4">
        <Button internalType="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button internalType="accept" onClick={handleAssign} disabled={!email.trim() || assigning}>
          {assigning ? 'Assigning...' : 'Assign Seat'}
        </Button>
      </div>
    </Modal>
  )
}

export default AssignPaidUserModal
